import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useQuery } from "@tanstack/react-query";

type UseGeneralDocumentsProps<T> = {
  id?: string
  mapper?: (data: any) => T,
}

export const useGeneralDocument = <T,>({
  id,
}: UseGeneralDocumentsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data,
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['generalDocument'],
    queryFn: () => {
      return privateAxios.get(`/general_documents/${id}`)
    },
    select: (data) => {
      return {
        data: data?.data?.data,
      };
    },
  })

  return { data, isPending, ...rest }
}
